import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  getAccountStatusRequest,
  DeleteUserRequest,
} from "../../services/APIService";

interface State {
  token: string;
  accountStatus: string;
  testAlarms: number;
  isExpired: boolean;
  showPayModal: boolean; // <-- Neu
}

export const useSettingsVM = (
  tag: string,
  initialToken: string,
  initialTestAlarms: number,
  loggedID: string,
  onCloseModal?: () => void
) => {
  const navigate = useNavigate();

  const [state, setState] = useState<State>({
    token: initialToken,
    accountStatus: "",
    testAlarms: initialTestAlarms,
    isExpired: false,
    showPayModal: false, // <-- Neu
  });

  const loadStatus = async () => {
    try {
      const data = await getAccountStatusRequest(tag);
      const accountStatus = data.accountStatus;
      const isExpired = checkIsExpired(accountStatus);
      setState((prev) => ({ ...prev, accountStatus, isExpired }));
    } catch (error) {
      console.error("Fehler beim Laden des Account Status:", error);
    }
  };

  useEffect(() => {
    loadStatus();
  }, [tag]);

  const checkIsExpired = (accountStatus: string) => {
    if (accountStatus === "Test") return true;
    if (accountStatus === "Payed") return false;
    
    const today = new Date();
    const expirationDate = new Date(accountStatus);
    
    // Warnung 7 Tage vor Ablauf anzeigen
    const daysBeforeWarning = 7;
    const warningWindow = daysBeforeWarning * 24 * 60 * 60 * 1000;

    return expirationDate.getTime() - today.getTime() <= warningWindow;
  };

  // Beim Klick auf Verlängern Modal öffnen
  const onAboExtendClick = () => {
    setState((prev) => ({ ...prev, showPayModal: true }));
  };

  const closePayModal = () => {
    setState((prev) => ({ ...prev, showPayModal: false }));
    loadStatus(); // Aktualisiert das Datum nach dem Bezahlen frisch
  };

  const onDeleteAccountClick = async () => {
    try {
      await DeleteUserRequest(loggedID);
      if (onCloseModal) onCloseModal();
      navigate("/Login");
    } catch (error) {
      console.error("Fehler beim Löschen des Accounts:", error);
      alert("Der Account konnte nicht gelöscht werden.");
    }
  };

  const onBackClick = () => {
    if (onCloseModal) {
      onCloseModal();
    } else {
      navigate("/MainPage");
    }
  };

  return {
    state,
    actions: {
      onAboExtendClick,
      closePayModal,
      onDeleteAccountClick,
      onBackClick,
    },
  };
};